import Vue from "vue";
import VueI18n from "vue-i18n";

import korean from "@/lang/korean.json";
import english from "@/lang/english.json";

Vue.use(VueI18n);

const messages = {
  korean,
  english,
};

let locale = "";
let ls_lang = localStorage.getItem("lang");

if (ls_lang !== null) {
  /**
   * 로컬스토리지에 값이 있는 경우
   */
  locale = ls_lang;
} else {
  /*
   * 로컬스토리지에 값이 없는 경우 브라우저 언어 체크
   */
  let lang = getLanguage();

  if (lang === "en-US" || lang === "en") {
    locale = "english";
  } else if (lang === "ko-KR" || lang === "ko") {
    locale = "korean";
  } else {
    locale = "english";
  }
}

function getLanguage() {
  return navigator.language || navigator.userLanguage;
}

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: "en",
  messages,
});

export default i18n;
